import React from 'react';
import { Box } from '@mui/material';
import theme from 'config/theme';
import { styles } from './teamChip.style';

const TEAM_BACKGROUND_COLORS = {
  Product: theme.palette.fukshias.fukshia200,
  'Customer Success': theme.palette.teals.teal200,
  Sales: theme.palette.mints.mint200,
  Engineering: theme.palette.lines.line200,
  Marketing: theme.palette.oranges.orange200,
  Finance: theme.palette.reds.red200,
  instaride: theme.palette.purples.purple200,
  Treasury: theme.palette.yellows.yellow200,
  Drivers: theme.palette.pinks.pink200,
  HR: theme.palette.violets.violet200,
  Accounting: theme.palette.greens.green200,
  Sourcing: theme.palette.babyBlues.babyBlue200,
  'Credit Control': theme.palette.fukshias.fukshia200,
};
const TEAM_COLORS = {
  Product: theme.palette.fukshias.fukshia900,
  'Customer Success': theme.palette.teals.teal900,
  Sales: theme.palette.mints.mint900,
  Engineering: theme.palette.lines.line900,
  Marketing: theme.palette.oranges.orange900,
  Finance: theme.palette.reds.red900,
  instaride: theme.palette.purples.purple900,
  Treasury: theme.palette.yellows.yellow900,
  Drivers: theme.palette.pinks.pink900,
  HR: theme.palette.violets.violet900,
  Accounting: theme.palette.greens.green900,
  Sourcing: theme.palette.babyBlues.babyBlue900,
  'Credit Control': theme.palette.pinks.pink900,
};

const TeamChip = ({ team }) => {
  if (!team) return;
  return (
    <Box sx={styles.chip(TEAM_BACKGROUND_COLORS[team], TEAM_COLORS[team])}>
      <Box sx={styles.text(TEAM_COLORS[team])}>{team}</Box>
    </Box>
  );
};

export default TeamChip;
